var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BasicDialog',{attrs:{"title":_vm.title,"buttonText":_vm.buttonText},on:{"onClose":_vm.onClose,"onSubmit":_vm.goToProfile}},[_vm._v(" "+_vm._s(_vm.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }